export default {
 user: null,
 loading: false,
 userInfo: {},
 userRole: null,
 roles: {},
 // allPermissions: [],
 // allPermissionIds: [],
 permissionSlugs: []
}
